module.exports = __webpack_public_path__ + "img/mc_ismail.c4f0fde9.jpg";